import FabricCanvasTool from './fabrictool';

class Pointer extends FabricCanvasTool {
  configureCanvas(props) {
    let canvas = this._canvas;
    canvas.isDrawingMode = false;
    canvas.selection = false;
    canvas.forEachObject((o) => { o.selectable = o.evented = false; });
    canvas.defaultCursor = 'pointer';
    canvas.hoverCursor = 'pointer';
  }
}

export default Pointer;
